import { z } from 'zod';

export const changeInvestorCreditSplitGetResponseSchema = z.object({
  data: z.object({ options: z.array(z.string()).optional(), value: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
